const indexItems = [
  { title: '古装剧场', desc: '热播古装大剧合集', icon: 'ri-sword-line', count: '326部' },
  { title: '悬疑探案', desc: '烧脑推理高分神作', icon: 'ri-search-eye-line', count: '218部' },
  { title: '爱情甜宠', desc: '浪漫心动必看清单', icon: 'ri-heart-line', count: '452部' },
  { title: '院线大片', desc: '最新上映电影精选', icon: 'ri-film-line', count: '189部' },
  { title: '韩剧专场', desc: '高分韩剧一网打尽', icon: 'ri-vidicon-line', count: '276部' },
  { title: '美剧精选', desc: '口碑美剧全集放送', icon: 'ri-global-line', count: '198部' },
  { title: '动漫世界', desc: '热门动漫同步更新', icon: 'ri-ghost-line', count: '543部' },
  { title: '综艺娱乐', desc: '热门综艺爆笑不断', icon: 'ri-emotion-happy-line', count: '312部' },
  { title: '纪录片库', desc: '高分纪录探索世界', icon: 'ri-earth-line', count: '167部' },
];

export default function Index() {
  return (
    <section id="index" className="py-16 md:py-20 px-4 md:px-6 bg-background-950">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-1 h-7 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">专题合集</h2>
          <span className="text-xs text-foreground-500 bg-background-800/70 px-3 py-1 rounded-full">分类浏览</span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group flex items-center gap-3 md:gap-4 p-4 md:p-5 rounded-xl bg-background-800/30 hover:bg-background-800/60 border border-background-700/20 hover:border-accent-500/25 transition-all cursor-pointer"
            >
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-xl bg-accent-500/10 flex items-center justify-center group-hover:bg-accent-500/20 transition-colors">
                <i className={`${item.icon} text-accent-400 text-lg md:text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-100 group-hover:text-accent-400 transition-colors truncate">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
              </div>
              <span className="flex-shrink-0 text-xs text-foreground-600 bg-background-700/50 px-2 py-1 rounded-full">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}